import { z } from "zod";

export const incomeSchema = z.discriminatedUnion("incomeType", [
  z.object({ incomeType: z.literal("NONE") }),
  z.object({
    incomeType: z.enum([
      "SALARIED",
      "HOURLY",
      "HOURLY_COMMISSIONS",
      "COMMISSIONS",
      "SELF_EMPLOYED",
      "PENSION",
      "BONUS",
      "OVERTIME_AND_PREMIUMS",
      "SELF_EMPLOYED_STATED",
      "OTHER",
      "ON_CONTRACT",
      "SEASONAL",
      "FLUCTUATING_IRREGULAR",
      "EMPLOYED_BY_FAMILY",
      "PENSION_DISABILITY",
      "SPOUSAL_CHILD_SUPPORT",
      "LEAVE_OF_ABSENCE",
      "GOV_CHILDCARE_SOCIAL_ASSIST",
      "NON_CANADIAN_CURRENCY",
      "NON_TAXABLE_INCOME",
      "NORTHERN_ALLOWANCE",
      "FOSTER_CARE_INCOME",
      "RENTAL_INCOME",
      "INVESTMENT_INCOME",      
    ]),
    salary: z.object({
      base: z.object({
        amount: z.number(),
        frequency: z.string().min(1),
      }),
    }),
  }),
]);

export const incomeArraySchema = z.array(incomeSchema).min(1);
